<template>
    <div class="custom-tree-container" style="position: relative;">

        <div class="block" style="min-height: 300px;" <el-tree v-loading="load" :props="props" :data="data"
            node-key="id" default-expand-all :expand-on-click-node="false" draggable :allow-drop="allowDrop"
            :allow-drag="allowDrag" @node-drag-start="handleDragStart" @node-drag-enter="handleDragEnter"
            @node-drag-leave="handleDragLeave" @node-drag-over="handleDragOver" @node-drag-end="handleDragEnd"
            @node-drop="handleDrop">
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span v-if="!node.data.isEditing">{{ node.label }},{{ node.data.categoryId }}</span>
                <el-input v-if="node.data.isEditing" placeholder="title" v-model="node.data.categoryName"></el-input>
                <span>
                    <el-button type="text" size="mini" @click="() => editingStatusChange(node.data)">
                        {{ node.data.isEditing ? "Calcel" : "Edittt" }}
                    </el-button>
                    <el-button v-if="node.data.isEditing" type="text" size="mini" @click="saveNode(node.data)">
                        Save
                    </el-button>
                    <el-button type="text" size="mini" @click="() => appendMem(data)">
                        Append
                    </el-button>
                    <el-button type="text" size="mini" @click="() => deleteNode(data)">
                        Delete
                    </el-button>
                </span>
            </span>
            </el-tree>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

let id = 1000;

export default
    {
        data() {
            const data = [{
                id: 1,
                label: '一级 1',
                children: [{
                    id: 4,
                    label: '二级 1-1',
                    children: [{
                        id: 9,
                        label: '三级 1-1-1'
                    }, {
                        id: 10,
                        label: '三级 1-1-2'
                    }]
                }]
            }, {
                id: 2,
                label: '一级 2',
                children: [{
                    id: 5,
                    label: '二级 2-1'
                }, {
                    id: 6,
                    label: '二级 2-2'
                }]
            }, {
                id: 3,
                label: '一级 3',
                children: [{
                    id: 7,
                    label: '二级 3-1'
                }, {
                    id: 8,
                    label: '二级 3-2'
                }]
            }];
            return {

                // data : data,
                data: [],
                load: false,
                props: {
                    label: 'categoryName',
                    children: 'children',
                    isLeaf: 'leaf'
                },
            }
        },

        methods:
        {

            ...mapActions(['loadCategoriesFromAPI']),

            saveNode(data) {
                // 可能不存在于数据库中
                console.log(data)
                if (data.categoryId) {
                    this.updateApi(data)
                } else {
                    this.insertApi(data)
                }
            },
            moveNode(movingId, parentId) {
                console.log("move")
                console.log(movingId)
                console.log(parentId)
                const node = {
                    categoryId: movingId,
                    parentId: parentId
                }
                this.moveApi(node)
            },
            deleteNode(data) {
                const id = data.categoryId;
                this.deleteApi(id)
            },
            insertApi(node) {
                this.$axios.post(`/api/category/create`, node).then(res => {
                    console.log("ok")
                    this.fetchTags()

                })
            },
            moveApi(node) {
                this.$axios.post(`/api/category/move`, node).then(res => {
                    console.log("ok")
                    this.fetchTags()

                })
            },
            updateApi(node) {
                this.$axios.post(`/api/category/update`, node).then(res => {
                    console.log("ok")
                    this.fetchTags()
                })
            },
            deleteApi(id) {
                this.$axios.post(`/api/category/delete/${id}`).then(res => {
                    console.log("ok")
                    this.fetchTags()
                })
            },
            async fetchTags() {
                console.log("fetchTags")
                this.loadCategoriesFromAPI(this.$axios,true)
                this.$axios.get(`/api/category/tree`)

                    .then(res => {
                        console.log(res.data)
                        this.data = res.data

                    })
                    .catch(err => {

                    })

            },

            appendMem(data) {
                const newChild = { categoryId: null, parentId: data.categoryId, categoryName: 'testtest', isEditing: true, children: [] };
                if (!data.children) {
                    this.$set(data, 'children', []);
                }
                data.children.push(newChild);
            },

            remove(node, data) {
                const parent = node.parent;
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.id === data.id);
                children.splice(index, 1);
            },
            editingStatusChange(data) {
                if (typeof data.isEditing === 'undefined') {
                    this.$set(data, 'isEditing', true)
                } else {
                    data.isEditing = !data.isEditing
                }
            },


            handleDragStart(node, ev) {
                return
                console.log('drag start', node);
            },
            handleDragEnter(draggingNode, dropNode, ev) {
                return
                console.log('tree drag enter: ', dropNode.label);
            },
            handleDragLeave(draggingNode, dropNode, ev) {
                return
                console.log('tree drag leave: ', dropNode.label);
            },
            handleDragOver(draggingNode, dropNode, ev) {
                return
                console.log('tree drag over: ', dropNode.label);
            },
            handleDragEnd(draggingNode, dropNode, dropType, ev) {
                console.log(draggingNode)
                console.log(dropNode)
                console.log(dropType)
                console.log(ev)
                console.log('tree drag end: ', dropNode && dropNode.label, dropType);
                console.log(typeof (dropType))
                var parentId;
                if (dropType === "before" || dropType === "after") {
                    parentId = dropNode.data.parentId
                    console.log("parentId:" + parentId)

                } else if (dropType === "inner") {
                    parentId = dropNode.data.categoryId
                    console.log("parentId:" + parentId)
                }

                this.moveNode(draggingNode.data.categoryId, parentId);


            },
            handleDrop(draggingNode, dropNode, dropType, ev) {
                return
                console.log('tree drop: ', dropNode.label, dropType);
            },
            allowDrop(draggingNode, dropNode, type) {

                return true;
                if (dropNode.data.label === '二级 3-1') {
                    return type !== 'inner';
                } else {
                    return true;
                }
            },
            allowDrag(draggingNode) {
                if (draggingNode.data.isEditing) {
                    return false;
                }
                return true
                return draggingNode.data.label.indexOf('三级 3-2-2') === -1;
            },
        },
        mounted() {
            this.fetchTags()
        }
    };
</script>

<style>
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
